import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import PercentageDataPod from '../../../components/PercentageDataPod';

const messages = defineMessages({
  years4: {
    id: 'hubs.profiles.graduation-rate.4-years',
    defaultMessage: '4 Year',
  },
  years6: {
    id: 'hubs.profiles.graduation-rate.6-years',
    defaultMessage: '6 Year',
  },
  title: {
    id: 'hubs.profiles.graduation-rate.title',
    defaultMessage: 'Graduation Rate',
  },
  tooltip: {
    id: 'hubs.profiles.graduation-rate.tooltip',
    defaultMessage:
      "Bachelor's degree graduation rates of full-time, first-time, degree/certificate-seeking undergraduates within 4 or 6 years.",
  },
  linkText: {
    id: 'hubs.profiles.graduation-rate.link-text',
    defaultMessage: 'More about learning environment',
  },
});

function GraduationRate({ graduationRate4, graduationRate6, lastUpdated, intl }) {
  const values = [
    graduationRate4
      ? { label: intl.formatMessage(messages.years4), value: graduationRate4 }
      : false,
    graduationRate6
      ? { label: intl.formatMessage(messages.years6), value: graduationRate6 }
      : false,
  ].filter(i => i);

  return graduationRate4 || graduationRate6 ? (
    <PercentageDataPod
      header={intl.formatMessage(messages.title)}
      tooltip={intl.formatMessage(messages.tooltip)}
      footer={lastUpdated}
      isToggle
      content={{
        values,
        linkText: intl.formatMessage(messages.linkText),
        linkUrl: 'Studies',
      }}
    />
  ) : null;
}

export default injectIntl(GraduationRate);

GraduationRate.propTypes = {
  graduationRate4: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  graduationRate6: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  lastUpdated: PropTypes.string,
  intl: PropTypes.object,
};
